import React from 'react';
import PropTypes from 'prop-types';

import articleContentDefaultOptions from 'js/block-area/article-content-default-options';

import ComponentList from 'components/component-list';
import Layout from 'components/layout';

// A dedicated page for the member-registration form: the site chrome (header,
// footer, nav from Layout) wrapping only the RegisterMemberModule — nothing else.
// The wrapper breaks out of the centered content column so the form's beige
// background fills the full page width (see register-member-page.scss).
const RegisterMemberPage = ({ blocks, layout }) => (
  <Layout {...layout}>
    <div className="register-member-page">
      {blocks && <ComponentList {...blocks} {...articleContentDefaultOptions} />}
    </div>
  </Layout>
);

RegisterMemberPage.propTypes = {
  blocks: PropTypes.exact(ComponentList.propTypes),
  layout: PropTypes.exact(Layout.propTypes)
};

export default RegisterMemberPage;
